import type { Conversation } from '@/types/domain'

export function getConversationRecency(conversation: Conversation | null | undefined): string | null {
  return conversation?.last_message_at || conversation?.created_at || null
}

export function sortConversations(conversations: Conversation[]): Conversation[] {
  return conversations.slice().sort((a, b) => {
    const dateA = new Date(getConversationRecency(a) || 0).getTime()
    const dateB = new Date(getConversationRecency(b) || 0).getTime()
    return dateB - dateA
  })
}
